module.exports = "<ul class=\"schedule\">\n  <li class=\"schedule__time\" *ngFor=\"let datetime of datetimes\" [class.schedule__time--disabled]=\"isDatetimePast(datetime)\">{{ datetime | date:'HH:mm' }}</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/schedule/schedule.component.html
// module id = ../../../../../src/app/shared/schedule/schedule.component.html
// module chunks = 4